import styled, { css } from 'styled-components';

export const StyledStatusText = styled.span<{ alignWrappedText: boolean }>`
  display: inline-block;

  ${({ alignWrappedText }) => alignWrappedText && css`
    display: flex;
    align-items: center;
  `}
`;

export const StyledIcon = styled.svg<{ size: number; top: number; marginRight: number; marginLeft: number }>`
  position: relative;
  flex-shrink: 0;
  top: ${({ top }) => top}px;
  width: ${({ size }) => size}px;
  height: ${({ size }) => size}px;
  margin-left: ${({ marginLeft }) => marginLeft}px;
  margin-right: ${({ marginRight }) => marginRight}px;
  color: ${({ theme, color }) => color || theme.colors.primary}
`;
